import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import pluralize from 'pluralize'
import { useGoalHabits } from '../../lib/ctx'
import { formatK } from '@fable/utils'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

const generateYAxisTicks = (maxGoal: number, interval: number): number[] => {
  const ticks: number[] = []

  for (let i = 0; i <= maxGoal; i += interval) {
    ticks.push(i)
  }

  if (ticks[ticks.length - 1] !== maxGoal) {
    ticks.push(maxGoal)
  }

  return ticks
}

export const ChartYAxis = () => {
  const [type, max, weekYAxisInterval] = useGoalHabits((s) => [
    s.type,
    s.weekMaxValue,
    s.weekYAxisInterval,
  ])
  const theme = useStatsTheme((s) => s.theme)

  const getLabel = (num: number) => {
    switch (type) {
      case 'active_days':
        return pluralize('day', num)
      case 'books_finished':
        return pluralize('book', num)
      case 'pages_read':
        return pluralize('page', num)
    }
  }

  const yAxisTicks = generateYAxisTicks(max, weekYAxisInterval)

  return (
    <FlexBox flexDirection="column-reverse" justifyContent="space-between">
      {yAxisTicks.map((tick) => (
        <FlexBox
          key={tick}
          className={css`
            gap: 4px;
            position: relative;
            padding-right: 15px;
          `}
          alignItems="center"
        >
          <span
            className={css`
              width: 2px;
              height: 1px;
              background-color: ${theme.colors.section.textSecondary};
            `}
          />
          <Text
            type="body"
            className={css`
              font-size: 8px;
              line-height: 8px;
              display: ${tick === 0 || tick === max ? 'block' : 'none'};
              position: absolute;
              top: 50%;
              left: 4px;
              transform: translateY(-50%);
            `}
            weight="500"
            color={theme.colors.section.textSecondary}
          >
            {formatK(tick)}
            <br />
            {getLabel(tick)}
          </Text>
        </FlexBox>
      ))}
    </FlexBox>
  )
}
